import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Img = styled.img`
  width: 17.89px;
  height: 17.89px;
  margin-right: 4.03px;
  top: -2px;
  position: relative;
  ${(props) => props.fill && `fill: ${props.fill};`}
`;
const Checkbox = (props) => {
  const { title, checked, id, onCheck, svg, svgFill, className, classNameInput, disabled } = props;
  return (
    <div className={`form-check margin-0 ${className}`}>
      <input
        onClick={onCheck}
        type="checkbox"
        checked={checked}
        className={`form-check-input h4 margin-right-10 ${classNameInput}`}
        id={id}
        disabled={disabled}
      />
      {svg && <Img src={svg} fill={svgFill} />}
      <label className="form-check-label h4" htmlFor={id}>
        {title}
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  checked: PropTypes.bool,
  onCheck: PropTypes.func.isRequired,
  svg: PropTypes.string,
  svgFill: PropTypes.string,
  className: PropTypes.string,
  classNameInput: PropTypes.string,
};

Checkbox.defaultProps = {
  title: "",
  checked: false,
  svg: "",
  svgFill: "",
  className: "",
  classNameInput: "",
};

export default Checkbox;
